document.addEventListener("DOMContentLoaded", () => {
  const roots = document.querySelectorAll("[data-ir-phg]");
  if (!roots.length) return;

  roots.forEach((root) => {
    const mainWrap = root.querySelector("[data-ir-phg-main]");
    const mainImg = root.querySelector("[data-ir-phg-main-img]");
    const thumbs = Array.from(root.querySelectorAll("[data-ir-phg-thumb]"));
    const btnPrev = root.querySelector("[data-ir-phg-prev]");
    const btnNext = root.querySelector("[data-ir-phg-next]");
    if (!mainImg || !thumbs.length) return;

    let index = Math.max(
      0,
      thumbs.findIndex((t) => t.classList.contains("is-active"))
    );
    if (index < 0) index = 0;

    const preload = (src, srcset) => {
      const img = new Image();
      if (srcset) img.srcset = srcset;
      if (src) img.src = src;
    };

    thumbs.forEach((t) => {
      const s = t.getAttribute("data-src");
      const ss = t.getAttribute("data-srcset");
      preload(s, ss);
    });

    let rafLock = false;

    const animateMain = () => {
      if (rafLock) return;
      rafLock = true;

      mainImg.classList.remove("is-ready");
      mainImg.classList.add("is-swapping");
      if (mainWrap) mainWrap.classList.add("is-swapping");

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          mainImg.classList.add("is-ready");
          mainImg.classList.remove("is-swapping");
          if (mainWrap) mainWrap.classList.remove("is-swapping");
          rafLock = false;
        });
      });
    };

    const setActive = (nextIndex, userScroll = true) => {
      const total = thumbs.length;
      if (!total) return;

      if (nextIndex < 0) nextIndex = total - 1;
      if (nextIndex >= total) nextIndex = 0;
      index = nextIndex;

      const btn = thumbs[index];
      const src = btn.getAttribute("data-src");
      const srcset = btn.getAttribute("data-srcset");
      const w = btn.getAttribute("data-width");
      const h = btn.getAttribute("data-height");
      const alt = btn.getAttribute("data-alt") || "";

      animateMain();

      if (src) mainImg.setAttribute("src", src);
      if (srcset) mainImg.setAttribute("srcset", srcset);
      if (w) mainImg.setAttribute("width", w);
      if (h) mainImg.setAttribute("height", h);
      mainImg.setAttribute("alt", alt);

      thumbs.forEach((t, i) => {
        const active = i === index;
        t.classList.toggle("is-active", active);
        t.setAttribute("aria-selected", active ? "true" : "false");
      });

      if (userScroll) {
        btn.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
      }
    };

    const inView = (el) => {
      el.classList.add("is-inview");
    };

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            inView(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18 }
    );

    const revealTargets = [
      root.querySelector(".ir-phg__left"),
      root.querySelector(".ir-phg__right"),
      root.querySelector(".ir-phg__thumbs"),
    ].filter(Boolean);

    revealTargets.forEach((el) => io.observe(el));

    thumbs.forEach((btn, i) => {
      btn.addEventListener("click", () => setActive(i));
    });

    if (btnPrev) btnPrev.addEventListener("click", () => setActive(index - 1));
    if (btnNext) btnNext.addEventListener("click", () => setActive(index + 1));

    root.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft") setActive(index - 1);
      if (e.key === "ArrowRight") setActive(index + 1);
    });

    setActive(index, false);
  });
});